import { apiBasename, csrf_token } from "./http-client";
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

// base query
export const baseQuery = fetchBaseQuery({
    baseUrl: apiBasename,
    credentials: "include",
    prepareHeaders: (headers, { getState }) => {
        const token = getState().auth.token;
        if (token) {
            headers.set("Authorization", `Bearer ${token}`);
        }
        headers.set("Content-Type", "application/json");
        headers.set("Accept", "application/json");
        headers.set("X-CSRF-TOKEN", csrf_token);
        return headers;
    },
});

// base query with re-auth
export const baseQueryWithReauth = async (args, api, extraOptions) => {
    let result = await baseQuery(args, api, extraOptions);

    if (result?.error?.originalStatus === 403) {
        console.log("sending refresh token");
        // send refresh token to get new access token
        const refreshResult = await baseQuery("/api/v1/auth/refresh", api, extraOptions);
        console.log(refreshResult);

        if (refreshResult?.data) {
            const user = api.getState().auth.user;
            // store the new token
            api.dispatch(
                setCredentials({
                    user: user,
                    token: refreshResult?.data.accessToken,
                })
            );
            // retry the original query with new access token
            result = await baseQuery(args, api, extraOptions);
        } else {
            api.dispatch(logOut());
        }
    }

    return result;
};

// initialize an empty api service that we'll inject endpoints into later as needed
export const soddApi = createApi({
    reducerPath: "soddApi",
    timeout: 15000, //milliseconds
    keepUnusedDataFor: 5,
    refetchOnReconnect: true,
    baseQuery: baseQueryWithReauth,
    endpoints: () => ({}),
});
